import UpdateChackValveDetail from "../components/configuration/chackValveDetail/UpdateChackValveDetail";

const UpdateChackValveDetailPage = () =>{
    return(
        <UpdateChackValveDetail/>
    )
}   

export default UpdateChackValveDetailPage;
